// import https from "https";
import spilImage from "@/assets/images/icons/logo_tms_spil.svg";
import fwdImage from "@/assets/images/icons/logo_tms_forwarder.svg";

// const agent = new https.Agent({
//   rejectUnauthorized: false,
// });

let isProduction = true; //TRUE IF PROD, FALSE IF DEV
let isServer = true; //TRUE IF DEPLOYED ON SERVER, FALSE IF DEPLOYED ON LOCAL

let config = {
  // Revamp API URL
  // reApiUrl: "http://localhost:8000/api", //local/
  // reApiUrl: "https://forsisdex.forwarder.ai/dev/api", //dev
  reApiUrl: "https://forsisdex.forwarder.ai/api", //prod
  // Revamp API URL

  baseApiUrl: "https://tms.forwarder.ai:3000/tmsapi", //prod https
  // baseApiUrl: "http://10.11.11.155:3000/tmsapi", //prod http
  // baseApiUrl: "https://tms.forwarder.ai:3005/tmsapi", //dev https
  // baseApiUrl: "http://10.11.11.155:3005/tmsapi", //dev http
  // baseApiUrl: "http://localhost:3005/tmsapi", //local
  // spildexApiUrl: "http://nanika.spil.co.id:3000/spildex", //spildex http
  spildexApiUrl: "https://nanika.spil.co.id:8084/spildex", //spildex https
  // spildexApiUrl: "http://localhost:3004/spildex", //local
  // baseFileUrl: "https://forwarder.ai/Files/TMS-FS-DEV/", //dev
  // getImageUrl: "https://forwarder.ai/Files/TMS-FS-DEV/get_file.php", //dev
  // uploadImageUrl: "https://forwarder.ai/Files/TMS-FS-DEV/upload_file_prod.php", //dev
  // downloadImageUrl: "https://forwarder.ai/Files/TMS-FS-DEV/download.php", //dev
  // downloadFordriveImage: "https://api.forwarder.ai/attch/fordrive/download_fordrive.php", //dev
  // downloadDocTemplate: "https://forwarder.ai/Files/TMS-FS-DEV/download_straight.php", //dev
  // fordexApiUrl: "https://platform-api.forwarder.ai/fordex-sandbox", //fordex dev — NONAKTIF, FAST lewat tms_reapi
  baseFileUrl: "https://forwarder.ai/Files/TMS-FS/", //prod
  getImageUrl: "https://forwarder.ai/Files/TMS-FS/get_file.php", // prod
  uploadImageUrl: "https://forwarder.ai/Files/TMS-FS/upload_file_prod.php", // prod
  downloadImageUrl: "https://forwarder.ai/Files/TMS-FS/download.php", // prod
  downloadFordriveImage:"https://api.forwarder.ai/attch/fordrive/download_fordrive.php", // prod
  downloadDocTemplate:"https://forwarder.ai/Files/TMS-FS/download_straight.php", // prod
  // fordexApiUrl: "https://platform-api.forwarder.ai/fordex", // fordex prod — NONAKTIF, FAST lewat tms_reapi
  secretKey: "xuqAsjYDg2jtdPmpR4AZ",
  owner: [
    {
      id: 1,
      name: "FORWARDER",
      url: "tms.forwarder.ai",
      loginFile: "LoginPageForwarder",
      logoFile: "logo_tms_forwarder.svg",
      iconFile: "logo_tms_forwarder.svg",
      cssFile: [
        "main.css",
        "login_forwarder.css",
        "admin_forwarder.css",
        "theme_forwarder.css",
      ],
      meta: {
        title: "TMS Forwarder",
        description: "TMS Command Center by Forwarder",
        image: fwdImage,
      },
      chatBotStreamUrl: "https://nanika.spil.co.id:8081",
      gmapsKey:
        isServer == true
          ? "AIzaSyDeIOnEfnGW809a2C8R4TmM6OOCILDEi34"
          : "AIzaSyAVC6fohhxn7tRMpcFaVqRJ-uJ4JxjSzfU",
      localStorageKey:
        isProduction == true
          ? "qT9687qrjvvmkUzQ3xjB18njmkHYBH"
          : "xBQ6wr6ooUfzcMP7XcScWNl0V7hP2J",
    },
    {
      id: 2,
      name: "SPIL",
      url: "tms.spil.co.id",
      loginFile: "LoginPageSpil",
      logoFile: "logoTMScc_vertical.svg",
      iconFile: "logo_tms_spil.svg",
      cssFile: [
        "main.css",
        "login_spil.css",
        "admin_spil.css",
        "theme_spil.css",
      ],
      meta: {
        title: "TMS SPIL",
        description: "TMS Command Center by SPIL",
        image: spilImage,
      },
      chatBotStreamUrl: "https://nanika.spil.co.id:8083",
      gmapsKey:
        isServer == true
          ? "AIzaSyAVC6fohhxn7tRMpcFaVqRJ-uJ4JxjSzfU"
          : "AIzaSyAVC6fohhxn7tRMpcFaVqRJ-uJ4JxjSzfU",
      localStorageKey:
        isProduction == true
          ? "e9Oa6yiWxYWEjZOuzQ746cwq0wEzKw"
          : "bqDouRjuuIb4CM7TRLEODbUSjdEN6a",
    },
  ],
  activeOwner: 1, //OWNER = FORWARDER
  // activeOwner: 2, //OWNER = SPIL
  isProd: isProduction,
};

export default config;
